import { motion } from 'framer-motion';

export default function KpiGrid({ items }) {
  return (
    <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 lg:grid-cols-5">
      {items.map(({ title, value, delta, icon: Icon }, idx) => (
        <motion.div key={title} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: idx * 0.05 }} className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
          <div className="flex justify-between items-start">
            <div>
              <p className="text-xs text-gray-500">{title}</p>
              <h3 className="mt-1 text-xl font-bold">{value}</h3>
            </div>
            <div className="flex justify-center items-center w-10 h-10 text-emerald-600 bg-emerald-50 rounded-lg"><Icon size={18} /></div>
          </div>
          <div className="inline-flex gap-1 items-center mt-3 text-xs text-emerald-600">{delta}</div>
        </motion.div>
      ))}
    </div>
  );
}


